import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ContextMenuButton, NameEmailAvatar } from '../../../../../ui';
import { PartnerUser } from '../../../../../utils/types/admin_types';

const TooltipWrapper: React.FC<{ text?: string | null }> = ({ text }) => {
  const displayText = text || '-';
  return (
    <Tooltip title={displayText} arrow placement='top'>
      <Typography
        sx={{
          maxWidth: 220,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontSize: '0.8125rem',
          color: 'text.secondary',
          cursor: 'default',
        }}
      >
        {displayText}
      </Typography>
    </Tooltip>
  );
};

interface GetColumnsArgs {
  handleOpenMenu: (
    e: React.MouseEvent<HTMLButtonElement>,
    row: PartnerUser,
  ) => void;
  handleCloseMenu: () => void;
  anchorEl: HTMLElement | null;
}

export const getColumns = ({
  handleOpenMenu,
  handleCloseMenu,
  anchorEl,
}: GetColumnsArgs) => {
  return [
    {
      key: 'Name',
      label: 'Name',
      width: '250px',
      align: 'left' as const,
      render: (row: PartnerUser) => (
        <NameEmailAvatar
          email={row.user?.email}
          name={`${row.user?.firstName || ''} ${row.user?.lastName || ''}`.trim()}
          avatar={row.user?.profilePic}
        />
      ),
      disableSort: true,
    },
    {
      key: 'Email',
      label: 'Email',
      width: '250px',
      align: 'left' as const,
      render: (row: PartnerUser) => (
        <TooltipWrapper text={row.user?.email} />
      ),
      disableSort: true,
    },
    {
      key: 'Groups',
      label: 'Groups',
      width: '220px',
      align: 'left' as const,
      render: (row: PartnerUser) => (
        <TooltipWrapper
          text={row.groups?.map((group) => group.groupName).join(', ') || 'Empty'}
        />
      ),
      disableSort: true,
    },
    {
      key: 'Last Active',
      label: 'Last Active',
      width: '200px',
      align: 'left' as const,
      render: (row: PartnerUser) => (
        <TooltipWrapper
          text={
            row.lastActive
              ? new Date(row.lastActive * 1000).toLocaleString()
              : 'Never Logged-In'
          }
        />
      ),
      disableSort: true,
    },
    {
      key: 'Actions',
      label: '',
      width: '80px',
      align: 'right' as const,
      render: (row: PartnerUser) => (
        <ContextMenuButton
          row={row}
          onOpenMenu={(e, r) => handleOpenMenu(e, r as PartnerUser)}
          onCloseMenu={handleCloseMenu}
          anchorEl={anchorEl}
        />
      ),
      disableSort: true,
    },
  ];
};
